<template>
    <section
        v-if="packages.length"
        class="package-recommendations"
    >
        <h2 class="package-recommendations__title k-heading-3">
            More holiday packages
        </h2>

        <div class="package-recommendations__grid">
            <PackageCard
                v-for="packageItem in packages"
                :key="packageItem.uuid"
                :package-data="packageItem"
                @select="track(packageItem, $event)"
            />
        </div>
    </section>
</template>

<script setup>
import PackageCard from '~/components/package-card/package-card.vue'

const { packages = [] } = defineProps({
    packages: {
        type: Array,
        default: () => [],
    },
})

const { capture } = useTracking()

function track(packageItem, action) {
    capture('related_package_clicked', {
        placement: 'package-recommendations',
        target_slug: packageItem.full_slug,
        action,
    })
}
</script>

<style lang="scss" scoped>
@use '@vemedia/bcn-components/scss/responsive' as *;

.package-recommendations {
    margin-block: var(--space-7);

    &__title {
        margin-bottom: 1.25rem;
    }

    &__grid {
        display: grid;
        gap: var(--space-5);

        @include tablet {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }

        @include desktop {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }
    }
}
</style>
